import { OnInit } from '@angular/core';
import { ProducerService } from '@sc/pas-common';
import { AuthService } from '@sc/pas-common';
import { AuthGuardService } from '@sc/pas-common';
var SingleSignatureCreditComponent = /** @class */ (function () {
    function SingleSignatureCreditComponent(producerService, authGuardService, auth) {
        this.producerService = producerService;
        this.authGuardService = authGuardService;
        this.auth = auth;
        this.openMenu = false;
        this.notAllowedCuit = false;
        this.selectedBranchIcon = '';
        this.loading = false;
        this.selectorTitle = 'Seleccione un productor';
    }
    SingleSignatureCreditComponent.prototype.ngOnInit = function () {
    };
    SingleSignatureCreditComponent.prototype.openPASSelector = function () {
        var _this = this;
        this.loading = true;
        this.producerService.getByUserID(this.authGuardService.user).subscribe(function (producers) {
            _this.producers = producers;
            _this.openMenu = true;
        });
    };
    SingleSignatureCreditComponent.prototype.handleOnPasClick = function (producer) {
        var _this = this;
        this.openMenu = false;
        this.auth.generateSingleSignatureCreditAccess(producer.cuit).subscribe(function (response) {
            _this.loading = false;
            if (response.url) {
                window.open(response.url, '_blank');
            }
            else {
                _this.notAllowedCuit = true;
            }
        }, function (error) {
            _this.loading = false;
            console.log('response', error);
        });
    };
    SingleSignatureCreditComponent.prototype.closeLateralMenu = function () {
        this.loading = false;
        this.openMenu = false;
    };
    return SingleSignatureCreditComponent;
}());
export { SingleSignatureCreditComponent };
